import React from "react";
import { Link } from "react-router-dom";
import { Trans } from "react-i18next";
import { i18nextKeys } from "Lang/i18nextKeys";
import i18nextTranslate from "Lang/i18nextTranslate";
import investments_empty_state from "Assets/images/investments_empty_state.png";

const EmptyState = ({
  style = {},
}) => {
  const link = i18nextTranslate(i18nextKeys.customInvestmentsEmptyLink, { returnObjects: true });

  const linkButtonClassnames = "uppercase rounded-md flex items-center justify-center";
  const linkButtonStyles = {
    width: "180px",
    height: "48px",
    fontFamily: "Inter, sans-serif",
    color: "#001f3e",
    lineHeight: "100%",
    fontSize: "15px",
    fontWeight: "600",
    backgroundColor: "#68686821"
  };

  return (
    <div
      className="flex flex-col items-center justify-center"
      style={style}
    >
      <img
        src={investments_empty_state}
        width="200px"
        height="200px"
        alt="no assets"
      />
      <div
        className="mt-30 mb-16 px-16 md:px-0 text-center"
        style={{
          fontFamily: "Cuprum, sans-serif",
          fontSize: "26px"
        }}
      >
        {i18nextTranslate(i18nextKeys.customInvestmentsEmptyHeading)}
      </div>
      <div
        className="mb-24 px-16 md:px-0 text-center"
        style={{
          fontFamily: "DM Sans, sans-serif",
          fontSize: "14px",
          maxWidth: "450px"
        }}
      >
        <Trans i18nKey={i18nextKeys.customInvestmentsEmptyText}>
          <br />
        </Trans>
      </div>
      {link?.external ? (
        <a
          href={link?.href || undefined}
          target={link?.newTab ? "_blank" : "_self"}
          className={linkButtonClassnames}
          style={linkButtonStyles}
        >
          {link?.text}
        </a>
      ) : (
        <Link
          to={{ pathname: link?.path }}
          target={link?.newTab ? "_blank" : "_self"}
          className={linkButtonClassnames}
          style={linkButtonStyles}
        >
          {link?.text}
        </Link>
      )}
    </div>
  );
};

export default EmptyState;
